/* Page « Notre showroom » (DECOSYSTEME) : le pilotage au défilement.
   Adapté de la maquette validée (builds/showroom/index.html) pour la section deco-showroom du thème :
   - tout est rangé sous .sr : les variables sont posées sur .sr, jamais sur <html> ;
   - l'en-tête du thème reste collé en haut de l'écran : la zone utile commence sous lui ;
   - les positions sont mesurées dans la page (offsetTop cumulés) : ni la pile collée de l'entrée ni le décalage
     de « À propos » ne faussent la mesure ;
   - l'éditeur de thème recharge la section quand on change un réglage : le pilotage s'arrête puis repart. */
(() => {
  'use strict';
  const clamp01 = x => (x < 0 ? 0 : x > 1 ? 1 : x);
  const douce = t => { t = clamp01(t); return t * t * t * (t * (t * 6 - 15) + 10); };
  const etroit = () => innerWidth <= 860;
  // haut d'un élément dans la page, transformations ignorées
  const hautDansPage = el => { let t = 0; for (let n = el; n; n = n.offsetParent) t += n.offsetTop; return t; };

  function demarrer(root) {
    const reduit = !!ScrollCraft.reduce;
    // sans animation, la bascule est montrée dans son état final : son texte arrive dès l'entrée du temps
    if (reduit) root.querySelectorAll('.bascule__mot [data-sc-cue]').forEach((el, k) => el.setAttribute('data-sc-cue', (0.02 + k * 0.02) + ' 1 0.1 0'));
    const moteur = ScrollCraft.mount(root);
    const $ = (s, r = root) => r.querySelector(s);
    const $$ = (s, r = root) => [...r.querySelectorAll(s)];
    const vars = {};
    const setVar = (k, v) => { if (vars[k] !== v) { vars[k] = v; root.style.setProperty(k, v); } };
    const pAct = el => parseFloat(el.style.getPropertyValue('--sc-p')) || 0;
    let mort = false;

    /* ── le nuancier : les vrais tissus Richmond Interiors (photos HD des Fichiers de la boutique), du plus clair au plus foncé ── */
    let TISSUS = [];
    try { TISSUS = JSON.parse($('#sr-tissus').textContent); } catch (e) { TISSUS = []; }
    const N = TISSUS.length;
    const ul = $('#pastilles'), pile = $('#pile'), compte = $('#compte');
    const cartesTissu = TISSUS.map((t, i) => {
      const li = document.createElement('li');
      const b = document.createElement('button');
      b.className = 'pastille'; b.type = 'button'; b.dataset.i = i; b.title = t.nom;
      b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', t.nom);
      const s = document.createElement('span'); s.style.backgroundImage = `url("${t.vignette}")`;
      b.appendChild(s); li.appendChild(b); ul.appendChild(li);
      // srcset (27/10/2026) : 500 px suffisent sur un écran d'ordinateur standard (carte de ~400 px) ; 1000 px restent pour
      // les écrans haute densité et le téléphone, où le tissu doit rester net.
      // Vitesse (02/11/2026) : toutes les cartes en chargement différé (le nuancier est au milieu de la page ;
      // les 4 premières partaient avant, ~750 Ko au chargement)
      const carte = document.createElement('div');
      carte.className = 'carte-tissu'; carte.style.zIndex = String(100 - i);
      carte.innerHTML = `<div class="carte-tissu__img"><img src="${t.image}" srcset="${t.image.replace('width=1000', 'width=500')} 500w, ${t.image} 1000w" sizes="(max-width: 860px) 80vw, 30vw" alt="Tissu Richmond Interiors ${t.nom}, en gros plan" width="1024" height="1024" loading="lazy"></div>
        <div class="carte-tissu__pied"><span class="petit">Richmond Interiors</span><b>${t.nom}</b><small>Le même, à toucher au showroom</small></div>`;
      pile.appendChild(carte);
      return carte;
    });
    // position dans le nuancier (0 = première carte), suivie en douceur : la molette avance par crans
    let posL = 0, courant = -1;
    const debutTour = 0.06, finTour = 0.92;
    function poseNuancier(pos) {
      cartesTissu.forEach((c, k) => {
        const d = k - pos;
        let tr, op = 1;
        if (d <= -1) { tr = 'translate3d(-125%, 14%, 0) rotate(-13deg)'; op = 0; }
        else if (d < 0) {
          // la carte du dessus se soulève et sort franchement par la gauche, opaque : elle ne voile jamais la suivante
          const t = -d, e = t * t * (3 - 2 * t);
          tr = `translate3d(${(-125 * e).toFixed(2)}%, ${(14 * e - 5 * Math.sin(Math.PI * t)).toFixed(2)}%, 0) rotate(${(-13 * e).toFixed(2)}deg)`;
          op = t < 0.85 ? 1 : (1 - t) / 0.15;
        } else {
          // les suivantes attendent dessous, en éventail, et montent d'un cran à chaque carte tournée
          const s = Math.min(d, 3.4);
          tr = `translate3d(${(s * 15).toFixed(1)}px, ${(-s * 12).toFixed(1)}px, 0) rotate(${(s * 2.1).toFixed(2)}deg)`;
          op = d > 3 ? clamp01(4 - d) : 1;
        }
        c.style.transform = tr;
        c.style.opacity = op.toFixed(3);
      });
      const i = Math.min(N - 1, Math.max(0, Math.round(pos)));
      if (N && i !== courant) {
        courant = i;
        compte.textContent = String(i + 1).padStart(2, '0');
        $$('.pastille', ul).forEach((b, k) => b.setAttribute('aria-pressed', String(k === i)));
      }
    }

    /* ── pilotage : la balance penche, puis la ligne cède ── */
    const enTete = document.querySelector('#header-group .header-section') || document.querySelector('header-component');
    const actes = ['#apropos', '#interieur', '#asseoir', '#matiere', '#conseil'].map(s => $(s));
    const G = [50, 48, 46, 44, 42, 42];
    const basc = $('#bascule'), matiere = $('#matiere');
    let pbL = 0;   // progression de la bascule, lissée comme la tête de lecture de la vidéo

    // une pastille : on fait défiler la page jusqu'à cette carte, le nuancier suit
    ul.addEventListener('click', e => {
      const b = e.target.closest('.pastille'); if (!b || N < 2) return;
      const course = Math.max(1, matiere.offsetHeight - innerHeight);
      const p = debutTour + (+b.dataset.i / (N - 1)) * (finTour - debutTour);
      scrollTo({ top: hautDansPage(matiere) + p * course, behavior: reduit ? 'auto' : 'smooth' });
    });

    /* vidéo en boucle de la visite : chargée et lue seulement quand elle est à l'écran */
    const boucles = $$('video[data-boucle]');
    let io = null;
    if (!reduit && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(entrees => entrees.forEach(e => {
        const v = e.target;
        if (e.isIntersecting) {
          if (!v.src) v.src = (etroit() && v.dataset.srcMobile) || v.dataset.src;
          const lecture = v.play(); if (lecture) lecture.catch(() => {});
        } else if (!v.paused) v.pause();
      }), { rootMargin: '150px' });
      boucles.forEach(v => io.observe(v));
    }

    function cadre() {
      if (mort) return;
      const vh = innerHeight, vw = innerWidth, y = scrollY;
      // toutes les mesures d'abord, les écritures ensuite : la mise en page n'est pas recalculée en cours de route
      const haut = enTete ? Math.max(0, Math.min(vh, Math.round(enTete.getBoundingClientRect().bottom))) : 0;
      const tops = actes.map(a => hautDansPage(a));
      const hauteurs = actes.map(a => a.offsetHeight);
      const tB = hautDansPage(basc), hB = basc.offsetHeight;
      const rb = basc.getBoundingClientRect(), rm = matiere.getBoundingClientRect();
      const pb = pAct(basc), pm = pAct(matiere);

      setVar('--haut', haut + 'px');

      // 1 → 5 : le côté « site » se resserre un peu à chaque temps (50 % → 42 %)
      const milieu = y + vh * 0.5;
      let g = G[0];
      tops.forEach((t, i) => { if (milieu >= t) g = G[i] + (G[i + 1] - G[i]) * clamp01((milieu - t) / hauteurs[i]); });

      // 6 : la molette avance par crans ; on suit sa position en douceur au lieu de sauter d'un cran à l'autre
      if (reduit || rb.top > vh * 1.5 || rb.bottom < -vh * 0.5) pbL = pb;
      else { pbL += (pb - pbL) * 0.09; if (Math.abs(pb - pbL) < 0.0004) pbL = pb; }
      // la ligne cède (p 0.03 → 0.40), un temps en plein cadre, puis l'image se pose en portrait (p 0.46 → 0.72)
      const dansBascule = milieu >= tB;
      const b = reduit ? (dansBascule ? 1 : 0) : douce((pbL - 0.03) / 0.37);
      // les temps 1 à 5 ne bougent jamais avec la bascule : sinon leurs colonnes s'affinent hors écran et la page s'allonge
      const gb = reduit ? 0 : g * (1 - b);
      setVar('--g', (reduit ? 50 : g).toFixed(3) + '%');
      setVar('--gb', gb.toFixed(3) + '%');
      setVar('--gl', (reduit ? 50 : g * (1 - b)).toFixed(3) + '%');
      setVar('--g-m', (reduit ? 0 : 38 * (1 - b)).toFixed(3) + '%');
      // la scène collée commence sous l'en-tête : le portrait se règle sur la hauteur qui reste
      const portrait = Math.min((vh - haut) * 9 / 16, vw * 0.5);
      const pose = reduit ? 1 : douce((pbL - 0.46) / 0.26);
      const largeurSalle = vw * (1 - gb / 100);
      const couvre = largeurSalle + (portrait - largeurSalle) * pose;   // largeur que la vidéo doit couvrir
      const zoom = Math.max(1, couvre / portrait), decale = vw * gb / 100;
      setVar('--portrait', portrait.toFixed(1) + 'px');
      setVar('--decale', decale.toFixed(1) + 'px');
      setVar('--zoom', zoom.toFixed(4));
      setVar('--mot-x', portrait.toFixed(1) + 'px');
      setVar('--mot-o', (reduit ? 1 : clamp01((pbL - 0.6) / 0.08)).toFixed(3));
      // « Sur le site / Au showroom » : au début de chaque temps seulement ; plus bas, le contenu défile sous les
      // étiquettes et elles en cachaient une partie (audit UX du 22/10/2026)
      let depuis = Infinity;
      tops.forEach((t) => { if (y + haut >= t) depuis = y + haut - t; });
      const debutTemps = 1 - clamp01((depuis - 140) / 100);
      setVar('--libelles-o', ((1 - clamp01(b * 2.5)) * debutTemps).toFixed(3));

      // la ligne n'existe que dans la partie partagée : dès le haut de la page (« À propos ») jusqu'à la bascule
      const finPartage = tB + hB - vh;
      const dedans = y < finPartage && b < 0.98;
      setVar('--ligne-o', dedans ? '1' : '0');
      const debut = tops[0], fin = tB + vh * 0.2;
      setVar('--prog', clamp01((y + 80 - debut) / Math.max(1, fin - debut)).toFixed(4));

      // la matière : chaque cran de molette tourne la carte du dessus, en continu
      const cible = clamp01((pm - debutTour) / (finTour - debutTour)) * Math.max(0, N - 1);
      if (reduit || rm.top > vh * 1.5 || rm.bottom < -vh * 0.5) posL = cible;
      else { posL += (cible - posL) * 0.12; if (Math.abs(cible - posL) < 0.001) posL = cible; }
      poseNuancier(posL);

      requestAnimationFrame(cadre);
    }
    poseNuancier(0);
    requestAnimationFrame(cadre);

    // arrivée sur une ancre (#rendez-vous, retour du formulaire) : les temps épinglés viennent de prendre leur hauteur,
    // l'ancre a donc bougé ; on y retourne
    if (location.hash.length > 1) {
      let ancre = null;
      try { ancre = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) { ancre = null; }
      if (ancre && root.contains(ancre)) requestAnimationFrame(() => requestAnimationFrame(() => ancre.scrollIntoView({ block: 'start', behavior: 'instant' })));
    }

    return () => {
      mort = true;
      if (io) io.disconnect();
      moteur.destroy();
    };
  }

  let arret = null;
  const lancer = () => {
    if (arret) { arret(); arret = null; }
    const root = document.querySelector('.sr');
    if (root && window.ScrollCraft) arret = demarrer(root);
  };
  // éditeur de thème : la section est remplacée quand on change un réglage
  document.addEventListener('shopify:section:load', e => { if (e.target.querySelector && e.target.querySelector('.sr')) lancer(); });
  document.addEventListener('shopify:section:unload', e => {
    if (arret && e.target.querySelector && e.target.querySelector('.sr')) { arret(); arret = null; }
  });
  lancer();
})();
